import script from "./MobilePager.vue?vue&type=script&setup=true&lang=js"
export * from "./MobilePager.vue?vue&type=script&setup=true&lang=js"

import "./MobilePager.vue?vue&type=style&index=0&id=e4ff5d16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4ff5d16"]])

export default __exports__